import React from "react";
import { motion } from "framer-motion";
import { COMPLIANCE } from "@/content/services";

export const ComplianceRow = ({ className = "", compact = false, items = COMPLIANCE }) => (
  <motion.div
    className={`flex flex-wrap items-center gap-2.5 ${className}`}
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, delay: 0.9, ease: [0.22, 1, 0.36, 1] }}
    data-testid="compliance-badge-row"
  >
    <span className="text-[11px] font-semibold uppercase tracking-[0.25em] text-[#A6B0C9]">
      Compliance:
    </span>
    {items.map((c) => (
      <span
        key={c}
        className={`rounded-md border border-white/15 bg-white/5 font-medium uppercase tracking-wider text-[#DDE3F2] ${
          compact ? "px-2.5 py-1 text-[10px]" : "px-3 py-1.5 text-[11px]"
        }`}
        data-testid={`compliance-badge-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      >
        {c}
      </span>
    ))}
  </motion.div>
);
